import { useContext, useEffect, useState } from "react";
import { ContextApp } from "../../context/ContextApp";
import { validateVillages } from "../../helpers/validateForms";
import { TbVillages } from "../../components/tables/TbVillages"

import Titulo from "../../components/titles/Titulo"
import InputSearch from "../../components/inputs/inputs/InputSearch"
import InputJim from "../../components/inputs/inputs/InputJim"
import ModalConfirm from "../../components/ModalComfirm/ModalConfirm"

import '../pageStyles.css'
import './village.css'
import { getFormatFecha, getFormatInputFecha } from "../../helpers/dates";

const Villages = () => {

  const initialErrors = {
    nombre: '',
    provincia: '',
    ubicacion: '',
    hora: '',
    fecact: '',
    fecopen: '',
    fecclose: '',
  }

  const { loginUp, token, refreshToken, pueblo } = useContext(ContextApp);

  const [errors, setErrors] = useState(initialErrors);
  const [village, setVillage] = useState(pueblo)
  const [villages, setVillages] = useState([])
  const [villagesFiltred, setVillagesFiltred] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [modoAdd, setModoAdd] = useState(true)

  useEffect(() => {

    const loadData = async () => {
      try {
        await refreshToken();
        const data = await pueblo.getVillages();
        setVillages(await data);
        setVillagesFiltred(await data);


      } catch (error) {
        console.log(error.message)
      }
    }
    loadData();
  }, [pueblo, loginUp, refreshToken])

  const filterData = (data) => {
    const newData = villages.filter((village) => village.PUE_NOMBRE.toLowerCase().includes(data.toLowerCase()))
    setVillagesFiltred(newData)
  }

  const handleChange = (name, value) => {
    setVillage({ ...village, [name]: value })
  }

  const validateData = async (name, value) => {
    const error = await validateVillages(name, value)
    setErrors(prevErrors =>{
        return {...prevErrors, [name]:error}
      })
  }

  const sendForm = async () => {
    try {
      refreshToken()

      await validateData('nombre', village.nombre)
      await validateData('provincia', village.provincia)
      await validateData('ubicacion', village.ubicacion)
      await validateData('hora', village.hora)

      if (village.nombre.length > 2 
        && village.provincia.length > 2
        && village.ubicacion.length > 2
        && village.hora.length === 5) {
        modoAdd 
          ? setVillagesFiltred(await pueblo.addVillage(village, token))
          : setVillagesFiltred(await pueblo.updateVillage(village, token))
        setShowForm(false)
      }
    } catch (error) {
      console.log(error)
    }

  }
  const updateVillage = (e) => {

    setVillage({
      ...village,
      id: e.PUE_CLAVE,
      nombre: e.PUE_NOMBRE,
      provincia: e.PUE_PROVINCIA,
      ubicacion: e.PUE_UBICACION,
      hora: e.PUE_HORA,
      fecact: getFormatInputFecha(e.PUE_FECACT),
      fecopen: getFormatInputFecha(e.PUE_FECOPEN),
      fecclose: getFormatInputFecha(e.PUE_FECCLOSE),
    })
    setShowForm(true)
    setModoAdd(false)
  }
  const deleteVillage = async (e) => {
    setShowModal(!showModal) 

    await refreshToken()

    const data = await pueblo.delVillage(village.PUE_CLAVE, token)
    setVillagesFiltred(data)
    setVillage(pueblo)
  }
  const showPopup = (e) => {
    setVillage(e)
    setShowModal(!showModal) 
  }


  return (
    <>
    <div className="container-data">

      <section className="data-body">

        <section className="data-header">
          <Titulo>Pueblos</Titulo>

          <InputSearch
            placeholder='nombre a buscar'
            onChange={filterData} />
          <button className="material-icons-outlined btn" onClick={() => setShowForm(!showForm)}>add</button>
        </section>
        {villages &&
          <section className="data-table">

            <TbVillages
              villages={villagesFiltred}
              updateVillage={updateVillage}
              deleteVillage={showPopup} />

          </section>
        }
      </section>

      <section className="data-edit">
        {showForm &&
          <section className="data-form">

            <InputJim classN='span'
              type='text'
              name='nombre'
              value={village.nombre}
              onChange={handleChange}
              onBlur={validateData}
              placeholder='escribe nombre'
              error={errors.nombre} />
            <InputJim classN='span'
              type='text'
              name='provincia'
              value={village.provincia}
              onChange={handleChange}
              onBlur={validateData}
              placeholder='escribe provincia'
              error={errors.provincia} />
            <InputJim classN='span'
              type='text'
              name='ubicacion'
              value={village.ubicacion}
              onChange={handleChange}
              onBlur={validateData}
              placeholder='escribe ubicación'
              error={errors.ubicacion} />
            <InputJim classN=''
              type='time'
              name='hora'
              value={village.hora}
              onChange={handleChange}
              onBlur={validateData}
              label='Hora Actuación:'
              error={errors.hora} />
            <InputJim classN=''
              type='date'
              name='fecact'
              value={getFormatInputFecha(village.fecact)}
              onChange={handleChange}
              onBlur={validateData}
              label='Fecha Actuación:'
              error={errors.fecact} />
            <InputJim classN=''
              type='date'
              name='fecopen'
              value={getFormatInputFecha(village.fecopen)}
              onChange={handleChange}
              onBlur={validateData}
              label='Abrir Votos:'
              error={errors.fecopen} />
            <InputJim classN=''
              type='date'
              name='fecclose'
              value={getFormatInputFecha(village.fecclose)}
              onChange={handleChange}
              onBlur={validateData}
              label='Cerrar Votos:'
              error={errors.fecclose} />

            <button className="btn posButton" onClick={sendForm}>ENVIAR</button>
          </section>
        }
        <div className={showForm ? "data-logo hidden" : "data-logo"} />
      </section>

    </div>
    
{showModal &&
  <ModalConfirm title='Confirmar eliminación' showPopup={showPopup}>
    <>
      <section className='modal-message'>
        <h2>Vas a eliminar el pueblo</h2>
        <h2> {village.PUE_NOMBRE} ({getFormatFecha(village.PUE_FECACT)})</h2>
      </section>
      <section className='modal-buttons'>
        <button onClick={deleteVillage}>ACEPTAR</button>
        <button onClick={showPopup}>CANCELAR</button>
      </section>
    </>
  </ModalConfirm>
}
</>
  )
}
export default Villages

